import API from '../dataApi';

// -- Accounting: Donation Receipts ---------------------------------------------
export const getReceipts = (params) => API.get('/receipts', { params });
export const createReceipt = (data) => API.post('/receipts', data);
export const getReceipt = (id) => API.get(`/receipts/${id}`);
export const cancelReceipt = (id, reason) => API.delete(`/receipts/${id}`, { data: { reason } });
export const updateReceipt = (id, data) => API.patch(`/receipts/${id}`, data);
export const getGoldRegister = (params) => API.get('/receipts/gold-register', { params });
export const getItemRegister = (params) => API.get('/receipts/item-register', { params });
export const getAnonymousReceipts = (params) => API.get('/receipts/anonymous', { params });
export const getBhandarRegister = (params) => API.get('/receipts/bhandar-register', { params });
export const sendReceiptEmail = (id) => API.post(`/receipts/${id}/send-email`);
export const downloadReceiptPDF = (id) => API.get(`/receipts/${id}/pdf`, { responseType: 'blob' });
export const verifyMockPayment = (data) => API.post('/online-payment/verify-mock', data);
